<ng-container *ngIf="model">
    <mat-icon (click)="onClick($event, true)" [ngStyle]="{ display: myDisplay }">info</mat-icon>
    <mat-card appearance="outlined" [innerHTML]="model.text | trustHtml"></mat-card>
</ng-container>
